import { api } from "../api";

const expenseTypesFindAllByActivated = async (
    token: string,
    status: string,
) => {
    return api.get(`/expenses/types/${status}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export default expenseTypesFindAllByActivated;
